export const SALUTATION = {
    FEMALE: 1,
    MALE: 2
};

export type SalutationName = keyof typeof SALUTATION;

export type SalutationId = typeof SALUTATION.FEMALE | typeof SALUTATION.MALE;
